import { selectQuoteLine } from '@ui/features/quote-builder/state/selectors/quote-line';
import type { RootState } from '@ui/store';

import { getSnapOperationOrThrow } from '../utilities/selector-guards';

export const selectSnapOperation = (
  state: RootState,
  quoteLineUuid: string,
  snapOperationUuid: string,
) => {
  return getSnapOperationOrThrow(
    selectQuoteLine(state, quoteLineUuid),
    snapOperationUuid,
  );
};
